import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AccountRouterManager } from '../../controller/router-handler';
import { changeEmailModel } from '../../models/changeEmail.model';
import { accountInfoModel, putAccountConfirmServiceResModel, putAccountValidateServiceResModel } from '../../models/serviceResponse.model';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from '../../module-config/module-config';
import { AccountActions } from '../../ngrx/account-action-types';
import { ConfirmService } from '../../services/confirm.service';
import { ValidateService } from '../../services/validate.service';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css']
})
export class ChangeEmailComponent implements OnInit {
  obChangeEmail = new changeEmailModel('', '', '', '', '', '');
  accountInfo!: accountInfoModel;
  phoneNumber: string = '';

  private accountRouter = new AccountRouterManager(this.router);

  constructor(
    private router: Router, 
    private translate: TranslateService, 
    private toastr: ToastrService, 
    private validateService: ValidateService, 
    private confirmService: ConfirmService,
    private store: Store,
    @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig,
  ) {

    this.accountRouter.setRouterConfig(accountRouterConfig.displayAreaConfig);

    if(this.router.getCurrentNavigation()?.extras.state && this.router.getCurrentNavigation()?.extras.state?.accountInfo && this.router.getCurrentNavigation()?.extras.state?.type){
      this.accountInfo = this.router.getCurrentNavigation()?.extras.state?.accountInfo;
      this.obChangeEmail.type = this.router.getCurrentNavigation()?.extras.state?.type;
      if(this.obChangeEmail.type == 'email' && this.accountInfo && this.accountInfo.email){
        this.obChangeEmail.email = this.accountInfo.email;
      }
      if(this.obChangeEmail.type == 'phone' && this.accountInfo && this.accountInfo.countryCode && this.accountInfo.phone){
        this.obChangeEmail.phoneNumber = this.accountInfo.phone;
        this.obChangeEmail.countryCode = this.accountInfo.countryCode;
      }
    }
    else{
      this.accountRouter.toMyAccount();
    }
  }

  ngOnInit(): void {
  }

  async onValidate(){
    this.obChangeEmail.phoneNumber = this.phoneNumber.replace(/\D/g, "");
    this.obChangeEmail.countryCode = 'tr';

    if(this.obChangeEmail.type == 'email' && this.obChangeEmail.email == ''){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_EMAIL_MANDATORY_ERROR'));
      return;
    }

    if(this.obChangeEmail.type == 'phone' && this.obChangeEmail.phoneNumber == ''){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_EMAIL_MANDATORY_ERROR'));
      return;
    }

    if(this.obChangeEmail.type == 'phone' && this.phoneNumber.length != 15){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obChangeEmail.type == 'phone' && this.obChangeEmail.phoneNumber.length != 10){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obChangeEmail.type == 'email'){
      var emailRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      if(this.obChangeEmail.email.length <= 5 || !emailRegex.test(this.obChangeEmail.email)){
        this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_VALID_EMAIL_ERROR'));
        return;
      }
    }
    if(this.obChangeEmail.email == this.accountInfo.email){
      this.toastr.error(this.translate.instant('ACCOUNT_CHANGEEMAIL_REPEAT_ERROR'))
      return;
    }
    
    let message = await this.validate();
    if(message == ''){
      return;
    }
    else{
      this.toastr.error(message);
      return;
    }
  }

  async validate(){
    return this.callValidateFunction()
      .then(function(value){
        return '';
      })
      .catch(function(err){
        return err;
      })
  }

  callValidateFunction(){
    return new Promise((resolve, reject) => {
      this.validateService.putValidate(this.obChangeEmail).subscribe(
        (response: putAccountValidateServiceResModel) => {
          if(response.error === true){
            return reject(response.message);
          }
          else{
            this.obChangeEmail.refNo = response.refNo;
            return resolve(null);
          }
        },
        error => {
          return reject(error);
        }
      )
    });
  }

  async onConfirm(){
    if(this.obChangeEmail.otpCode == '' || this.obChangeEmail.otpCode.length != 5){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    let message = await this.confirm();
    if(message == ''){
      this.toastr.success('ACCOUNT_CHANGEEMAIL_SUCCESSFUL_MESSAGE');
      this.store.dispatch(AccountActions.updateUserInformation({userInfo: {id: this.accountInfo.userId, changes: {email: this.obChangeEmail.email}}}));
      this.accountRouter.toMyAccount();
    }
    else{
      this.toastr.error(message);
      return;
    }
  }

  async confirm(){
    return this.callConfirmFunction()
      .then(function(value){
        return '';
      })
      .catch(function(err){
        return err;
      })
  }

  callConfirmFunction(){
    return new Promise((resolve, reject) => {
      this.confirmService.postConfirm(this.obChangeEmail).subscribe(
        (response: putAccountConfirmServiceResModel) => {
          if(response.error === true){
            return reject(response.message);
          }
          else{
            return resolve(null);
          }
        },
        error => {
          return reject(error);
        }
      )
    });
  }
}
